module.exports = __webpack_public_path__ + "img/3.a0148119.webp";